import script from "./LocationQuestion.vue?vue&type=script&lang=ts&setup=true"
export * from "./LocationQuestion.vue?vue&type=script&lang=ts&setup=true"

import "./LocationQuestion.vue?vue&type=style&index=0&id=419a8834&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419a8834"]])

export default __exports__